import { HeaderLogo } from 'components/icons/menu-header-logo'
import { SettingsIcon} from 'components/icons/settings'
import React from 'react'
import * as Types from '../types'
import * as Utils from '../utils'

export enum TopicPreferencesLayoutAttributes {
  ShowHeader = 'topic_preferences_header_show',
  HeaderImageUrl = 'topic_preferences_header_image_url',
  HeaderText = 'topic_preferences_header_text',
  PageTitle = 'topic_preferences_page_title',
  HeaderDescription = 'topic_preferences_header_description',
  TopicCardSize = 'topic_preferences_card_size',
  TopicBorderColor = 'topic_preferences_border_color',
  ActiveTopicBorderColor = 'topic_preferences_active_border_color',
  BrandHeaderImageUrl = 'brand_header_image_url',
  SaveButtonText = 'topic_preferences_save_button_text',
  SaveButtonBackgroundColor = 'topic_preferences_save_button_background_color',
  SaveButtonTextColor = 'topic_preferences_save_button_text_color',
  EnableCustomTopics = 'topic_preferences_enable_custom_topics',
  HideRecommendedTopics = 'topic_preferences_hide_recommended_topics',
}

export const REDUX_STORE_HOME = 'topic_preferences_layout'

export enum MenuItems {
  headerAndLogo = 'Header and Description',
  appearance = 'Appearance',
  cta = 'CTA',
  topics = 'Topics Management',
}

export const MenuSections: Types.MenuSection[] = [
  {
    icon: <HeaderLogo />,
    key: Utils.getEnumHash(MenuItems.headerAndLogo, MenuItems),
    value: MenuItems.headerAndLogo,
  },
  {
    icon: <SettingsIcon svgwidth={27.5} svgheight={27.5} />,
    key: Utils.getEnumHash(MenuItems.appearance, MenuItems),
    value: MenuItems.appearance,
  },
  {
    icon: <SettingsIcon svgwidth={27.5} svgheight={27.5} />,
    key: Utils.getEnumHash(MenuItems.cta, MenuItems),
    value: MenuItems.cta,
  },
  {
    icon: <SettingsIcon svgwidth={27.5} svgheight={27.5} />,
    key: Utils.getEnumHash(MenuItems.topics, MenuItems),
    value: MenuItems.topics,
  },
]
